import React, { useEffect, useState } from "react";
import "../../App.css";
import { weatherLayerGroup } from "../weather/weatherLayer";

interface ForecastModelProps {
  setSelectedModel: (item: string) => void;
}

let weatherModel: string = "ECMWF"; 
const ForecastModel: React.FC<ForecastModelProps> = ({
  setSelectedModel,
}) => {
  const [selectedItem, setSelectedItem] = useState("ECMWF");

  const handleItemClick = (item: any) => {
      weatherLayerGroup.getLayers().clear();
    if (selectedItem === item) {
      setSelectedItem("ECMWF");
      setSelectedModel("ECMWF");
      weatherModel = "ECMWF";
    } else {
      setSelectedModel(item);
      setSelectedItem(item);
      weatherModel = item;
    }
  };

  useEffect(() => {
    setSelectedItem(weatherModel);
  }, []);
  
  useEffect(() => {
  }, [weatherModel]);


  return (
    <
    >
      <div
        className="forecast-model"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gridTemplateRows: "repeat(2, 1fr)",
          gap: "3px",
          backdropFilter: "blur(5.5px)",
          WebkitBackdropFilter: "blur(5.5px)",
        }}
    
      >
        <div
          className={`forecast-model-item ${
            selectedItem === "ECMWF" && "selected"
          }`}
          onClick={() => handleItemClick("ECMWF")}
          onTouchStart={() => handleItemClick("ECMWF")}
        >
          <span>ECMWF</span>
          <span style={{ fontSize: "8px", marginLeft: "2px" }}>9km</span>
        </div>
        <div
          className={`forecast-model-item ${
            selectedItem === "ICON" && "selected"
          }`}
          onClick={() => handleItemClick("ICON")}
          onTouchStart={() => handleItemClick("ICON")}
        >
          <span>ICON</span>
          <span style={{ fontSize: "8px", marginLeft: "2px" }}>13km</span>
        </div>
        <div
          className={`forecast-model-item ${
            selectedItem === "GFS" && "selected"
          }`}
          onClick={() => handleItemClick("GFS")}
          onTouchStart={() => handleItemClick("GFS")}
        >
          <span>GFS</span>
          <span style={{ fontSize: "8px", marginLeft: "2px" }}>22km</span>
        </div>

      </div>
    
    </>
  );
};

export default ForecastModel;
